
export default {
  name: 'AvatarProgress',

  props: {
    percentage: {
      type: Number,
      default: 0,
    },
    avatarUrl: {
      type: String,
      default: '',
    },
    initial: {
      type: String,
      default: '',
    },
    company: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
  },

  data(): Record<string, unknown> {
    return {
      statusColors: {
        completed: '#67C23A',
        invoices_sent: '#67C23A',
        cancelled: '#F56C6C',
        expired: '#F56C6C',
        request_expired: '#F56C6C',
        everythingElse: '#1060B0',
      },
    };
  },

  computed: {
    circleColor(): string {
      return this.statusColors[this.status] || this.statusColors.everythingElse;
    },
  },
};
